import type { PayloadAction, Slice } from "@reduxjs/toolkit";
import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import type { IQueuedDeviceActivationChange } from "@somewear/model";
import { emitOrganizationDevicesFetchedFromServer } from "@somewear/organization";

import type { SettingsState } from "./settings.state";

const adapter = createEntityAdapter<IQueuedDeviceActivationChange, string>({
	selectId: (change) => change.serial,
});

export const {
	selectAll: selectAllQueuedDeviceActivationChanges,
	selectById: selectQueuedDeviceActivationChangeBySerial,
	selectEntities: selectQueuedDeviceActivationChangeEntities,
} = adapter.getSelectors((state: SettingsState) => state.queuedDeviceActivationChanges);

export const queuedDeviceActivationChangeSlice: Slice = createSlice({
	name: "queuedDeviceActivations",
	initialState: adapter.getInitialState(),
	reducers: {
		bulkQueueActivationChange: (
			state,
			action: PayloadAction<IQueuedDeviceActivationChange[]>,
		) => {
			adapter.upsertMany(state, action.payload);
		},
		queueActivationChange: (state, action: PayloadAction<IQueuedDeviceActivationChange>) => {
			adapter.upsertOne(state, action.payload);
		},
		removeAllChanges: (state) => {
			adapter.removeAll(state);
		},
	},
	extraReducers: (builder) => {
		builder.addCase(emitOrganizationDevicesFetchedFromServer, (state, action) => {
			const serials = action.payload.devicesList.map((device) => device.serial);
			adapter.removeMany(state, serials);
		});
	},
});

export const { bulkQueueActivationChange, queueActivationChange } =
	queuedDeviceActivationChangeSlice.actions;
